import { useContext } from "react";
import CrudModuleFactoryModal from "@beeldit/core/components/CrudModuleFactoryModal";
import useGet from "./useGet";
import { t } from "i18next";
import { StatisticsActionContext } from "./StatisticsActionContext";

function useStatisticsAction(): any {
  const get = useGet();
  const getFunction = (id: number) => get(id);

  /** Creation and edition modal function and state definition */
  const { showModal, setShowModal } = useContext(StatisticsActionContext);

  /** Creation and edition modal element definition */
  const { element } = useContext(StatisticsActionContext);

  /**
   * Creation and edition modal configuration definition
   */
  const modalConfig = {
    title: t("statistics"),
    context: StatisticsActionContext,
    onSubmit: () => {
      setShowModal(false);
    },
  };

  const actionTemplate = (
    <CrudModuleFactoryModal modalConfig={modalConfig}>
      {element && (
        <>
        <div className="text-center">
          {
            element.img && element.img[0] && (
              <img className="statistics_img" src={element.img[0].url}></img>
            )            
          }  
          <h3 className="mt-5 mb-5">{element.full_name}</h3>
        </div>
        <div className="row">
          <div className="col-6">
            <h4>Liga actual</h4>            
            <div>Partidas ganadas: {element.statistics.current.won}</div>
            <div>Partidas perdidas: {element.statistics.current.lost}</div>
            <div>Sets ganados: {element.statistics.current.won_rounds}</div>
            <div>Sets perdidos: {element.statistics.current.lost_rounds}</div>
            <div>Ausencias: {element.statistics.current.forfeit}</div>
            <div>Position: {element.statistics.current.position}</div>
          </div>
          <div className="col-6">
            <h4>Global</h4>
            <div>Partidas ganadas: {element.statistics.global.won}</div>
            <div>Partidas perdidas: {element.statistics.global.lost}</div>
            <div>Sets ganados: {element.statistics.global.won_rounds}</div>
            <div>Sets perdidos: {element.statistics.global.lost_rounds}</div>
            <div>Ausencias: {element.statistics.global.forfeit}</div>
          </div>
        </div>
        </>
      )}
    </CrudModuleFactoryModal>
  );

  /** END EDIT FORM ACTION */

  return {
    getFunction,
    actionTemplate,
  };
}

export default useStatisticsAction;
